import {RESPONSE} from "../../../../../../constants/ResponseCodes";
import {VIEW} from "../../../../../workflow/Workflow";
import {getNotificationFormat} from "../../../../../utils/Util";
import {NOTIFICATION_TYPE} from "../../../../../../constants/NotificationType";
import {COMMON_STRINGS, NOTIFICATION_STRING, SCRUB_CONTAINER_STRINGS} from "../../../../../../constants/Strings";
import {getContainerRoutingPath, ROUTING} from "../../../../../../constants/Routing";
import {CONTAINER_TYPE} from "../../../../../../constants/ContainerType";

export const getScrubNonEmptyLocationViewData = (input) => {
    const values = {
        containerLabel: input.destinationLabel,
        displayBagId: input.displayBagId,
        destinationLabel: input.destinationLabel
    }

    switch (input.responseCode) {
        case RESPONSE.SUCCESS:
            return {
                view: VIEW.SCAN_BAG,
                notification: getNotificationFormat(NOTIFICATION_TYPE.SUCCESS, SCRUB_CONTAINER_STRINGS.location_scrub_success_open_bag_success, values)
            }
        case RESPONSE.NO_INTERNET:
            return {
                nextRoute: ROUTING.NO_INTERNET
            }
        case RESPONSE.NON_EMPTY_BAG:
            return {
                nextRoute: getContainerRoutingPath(ROUTING.REPLACE_CONTAINER, CONTAINER_TYPE.BAG),
                notification: getNotificationFormat(NOTIFICATION_TYPE.ERROR, NOTIFICATION_STRING.ALERT_ERROR_BAG_CANNOT_BE_USED, values)
            }
        case RESPONSE.INVALID_MOVE:
            return {
                view: VIEW.SCAN_BAG,
                notification: getNotificationFormat(NOTIFICATION_TYPE.ERROR, NOTIFICATION_STRING.ALERT_ERROR_BAG_CANNOT_BE_OPEN, values)
            }
        case RESPONSE.INVALID_SCAN_DONE:
            return {
                view: VIEW.SCAN_BAG,
                notification: getNotificationFormat(NOTIFICATION_TYPE.ERROR, NOTIFICATION_STRING.ALERT_ERROR_INVALID_LOCATION_SCANNED)
            }
        default:
            return {
                view: VIEW.SCAN_BAG,
                notification: getNotificationFormat(NOTIFICATION_TYPE.ERROR, COMMON_STRINGS.default_error)
            }
    }
}

export const getScrubLocationViewData = (input) => {
    const values = {
        containerLabel: input.destinationLabel,
    }

    switch (input.responseCode) {
        case RESPONSE.SUCCESS:
            return {}
        case RESPONSE.NO_INTERNET:
            return {
                nextRoute: ROUTING.NO_INTERNET
            }
        case RESPONSE.INVALID_MOVE:
        case RESPONSE.INVALID_SCAN_DONE:
            return {
                view: VIEW.SCAN_BAG,
                notification: getNotificationFormat(NOTIFICATION_TYPE.ERROR,
                    SCRUB_CONTAINER_STRINGS.scrub_location_invalid_scan, values)
            }
        default:
            return {
                view: VIEW.SCAN_BAG,
                notification: getNotificationFormat(NOTIFICATION_TYPE.ERROR, COMMON_STRINGS.default_error)
            }
    }
}
